export const gamboge = "#f59a1c";
export const gamboge2 = "#f5aa57";
export const dark_cyan = "#019497";
export const dark_cyan2 = "#86b8ba";
export const darker_cyan = "#005557";
export const darker_cyan2 = "#007275";